export default {
    props: {
        observations: Array
    },

    data() {
        return {
            clusterer: null,
            clustererOptions: {
                maxZoom: 16,
                styles: ['green'].map(color => ({
                    anchorText: [11, 0],
                    height: 35,
                    textColor: '#7DD69D',
                    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
                        this.getClusterIcon(color)
                    )}`,
                    width: 35,
                })),
            },
            google: null,
            map: null,
            mapReady: false,
            markers: [],
            spiderfier: null,
            spiderfierOptions: {
                basicFormatEvents: true,
                circleFootSeparation: 40,
                keepSpiderfied: true,
                markersWontHide: true,
                markersWontMove: true,
            },
        }
    },

    watch: {
        map(value) {
            if(! value) {
                return;
            }

            if(typeof this.observations == 'undefined' || ! this.observations.length) {
                return;
            }
        }
    },

    methods: {
        getClusterIcon(color) {
            return `
                <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="62.08" cy="10.56" r="12.54" transform="translate(-47 4)" fill="#053633" stroke="#FFF" stroke-width="3.96" fill-rule="evenodd"/>
                </svg>`;
        },
        getLeafIcon(color = 'green', isVertical = false) {
            return isVertical ? `/images/map/leaf-${color}-vertical.png` : `/images/map/leaf-${color}.png`;
        },
        getMarkerIcon(currentLocation = false) {
            return !currentLocation ? `/assets/svgs/marker.svg` : `/assets/svgs/current-marker-icon.svg`;
        },
        handleMapReady(map, google) {
            this.map = map;
            this.google = google;
            this.mapReady = true;
        },
    },
}
